import { Injectable } from '@angular/core';
import {
    Router,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class ProblemOrderServiceService {
    constructor(
        private router: Router,
        private localStorageService: LocalStorageService
    ) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        // const user = this.localStorageService.get('isAsendiaUser') ? true : false;
        const url = state.url;
        // if (!user) {
            this.router.navigateByUrl(url + '/online');
        // }
    }
}
